import React, { useContext, useMemo } from 'react'
import { ReturingCustomersLayoutContext } from '../ReturningCustomersLayout';
import RadioSelect from '../../../../components/RadioSelect/RadioSelect';
import { AiOutlineCheck } from 'react-icons/ai';
import { MainTracker } from '../../../../PixelTrackers/MainTracker';
import { translate, getPrice } from '../../../../utils/translator';
import { clientConfig } from '../../../../config';import { useCartContext } from '../../../../customHooks/useCart';

const formatDescription = (unformattedDescription: string, name: string, units: string) => {
    let copy = unformattedDescription.replace(":product_name", name);
    copy = copy.replace(":product_units", units);

    return copy;
};

const formatDiscount = (unformattedDescription: string, discount: number, locale: string, rate=1) => {
    const discountSpan = `<span class="bg-red-500 text-white text-sm font-medium px-1 py-0.5 rounded">${getPrice(discount, locale, rate)}</span>`;
    return unformattedDescription.replace(":discount", discountSpan);
};

interface SubscriptionOptionProps {
    planID: number,
    oneTime: boolean,
    maxDiscount?: number,
    isResponsiveLayout?: boolean
}

const SubscriptionOption: React.FC<SubscriptionOptionProps> = ({ planID, maxDiscount, isResponsiveLayout, oneTime = false }) => {

    const context = useContext(ReturingCustomersLayoutContext);
    const { cartCurrency } = useCartContext();

    const isSelected = context?.selectedSubscriptionPlanID === planID;
    const selectedProduct = context?.selectedProduct;
    const selectedProductItemID = context?.selectedProductItemID;
    const isExpressProductItem = context?.isExpressProductItem;
    const selectedItem = selectedProduct?.items.find((productItem) => productItem.product_item_id === selectedProductItemID);

    const planData = context?.subscriptionPlansData[planID];

    const onSelect = () => {
        context?.setSelectedSubscriptionPlanID(planID);

        if (oneTime) {
            window.eventsTracking.track({ e: "Choose One Time Purchase On Choose Treatment Page" });
        } else {
            MainTracker.track(
                "custom",
                "Choose Subscription On Choose Treatment Page"
            );
        }
    }

    const style = useMemo(() => {
        let css = 'text-md font-bold';
        if (isSelected) {
            css += ' text-[#269C6E]';
        } else {
            css += ' text-[#0d2c54]';
        }
        return css
    }, [isSelected])


    return (
        <div style={
            { border: isSelected ? "1px solid #269C6E" : "1px solid #e0e0e0" }
        } id={`plan_${planID  > 0 ?  planID : 'one_time'}${isResponsiveLayout ? "_responsive" : ""}`} onClick={onSelect} className={`cursor-pointer relative rounded-md p-4 ${isSelected ? "bg-[#F7FAEF]" : "bg-white"} `}>
            <div className='flex flex-col gap-2'>

                {planData?.discount === maxDiscount ? <p className="best-price">{translate(context?.languageID, "default", "SubscriptionOption/best_price")}</p> : null}

                <div className='flex gap-2 flex-row justify-between'>
                    <div className='flex items-center'>
                        <RadioSelect selected={isSelected} disabled={false} size={18} />
                        <p className={style}>
                            {planData?.choose_treatments_title || translate(context?.languageID, "default", "SubscriptionOption/one_time_purchase")}
                        </p>
                    </div>
                    {isExpressProductItem && <img className='' src={clientConfig.IMAGES_URL + "static_images/ExpressDeliveryTimes.svg"} width="120" height="28" alt="ExpressDeliveryTimes" />}
                    {!isExpressProductItem && <img className='' src={clientConfig.IMAGES_URL + "static_images/RegularDeliveryTimes.svg"} width="65" height="28" alt="RegularDeliveryTimes" />}
                </div>
                {oneTime ? <p className='plan-description'>{formatDescription(
                    translate(context?.languageID, "default", "SubscriptionOption/plan_description"),
                    selectedProduct!.title,
                    selectedItem!.custom_quantity_title
                )}</p> : null}

                {planData && <div>
                    <p className="plan-description ">
                        {formatDescription(
                            planData?.frequency_description,
                            selectedProduct!.title,
                            selectedItem!.custom_quantity_title
                        )}
                    </p>

                    <div className="saved-cost-description-container">
                        <AiOutlineCheck className="check-cost" />
                        <p className="saved-cost-description" 
                           dangerouslySetInnerHTML={{ 
                               __html: formatDiscount(
                                   translate(context?.languageID, "default", "SubscriptionOption/discount"),
                                   planData?.discount,
                                   cartCurrency.locale,
                                   cartCurrency.rate
                               )
                           }} />
                    </div>

                    <div className="saved-cost-description-container">
                        <AiOutlineCheck className="check-cost" />
                        <p className="saved-cost-description">
                            {translate(context?.languageID, "default", "SubscriptionOption/cancellable")}
                        </p>
                    </div>
                </div>
                }

                {oneTime && selectedProduct?.subscription_ftd ? (
                    <div className="saved-cost-description-container">
                        <AiOutlineCheck className="check-cost" />
                        <p className="saved-cost-description"
                           dangerouslySetInnerHTML={{ 
                               __html: formatDescription(
                                   translate(context?.languageID, "default", "SubscriptionOption/one_time_discount_description"),
                                   selectedProduct?.title,
                                   selectedItem!.custom_quantity_title
                               )
                           }} />
                    </div>
                ) : null}

            </div>
        </div>
    )
}

export default SubscriptionOption
